export default {
    methods: {
        showConfirm(index, link) {
            if (!this.userInfo.subscribe) {
                // 未关注
                this.$message.fail('未关注公众号')
                return
            }
            if (link) {
                window.location.href = link
                return
            }
            const { VUE_APP_MEMBER_FORMID } = window.env
            if (VUE_APP_MEMBER_FORMID) {
                window.location.href = `${window.env.VUE_APP_FORM +
                    window.env
                        .VUE_APP_MEMBER_FORMID}?redirect=${encodeURIComponent(
                    window.location.href
                )}`
                return
            }
            let setting
            if (
                index != null &&
                this.levelSettings[index] &&
                this.levelSettings[index].formIds.length
            ) {
                setting = this.levelSettings[index]
            } else {
                for (let item of this.levelSettings) {
                    if (item.formIds.length) {
                        setting = item
                        break
                    }
                }
            }
            if (setting) {
                window.location.href =
                    window.env.VUE_APP_FORM +
                    setting.formIds[setting.formIds.length - 1]
            } else {
                this.$message.fail('尚未设置会员申请表')
            }
        }
    }
}
